<template>
    <basic-header pretitle="Aqfer graph managment" title="Graph Visualizer" compact="true" />
    <div class="container-fluid">
        <tabs :tabs="visualizerTabs">
            <template v-slot:oltp><OltpGraphVisualizer></OltpGraphVisualizer></template>
            <template v-slot:olap><OlapGraphVisualizer></OlapGraphVisualizer></template>
        </tabs>
    </div>
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import Tabs from "../../components/Tabs.vue";
import OltpGraphVisualizer from "../../components/OltpGraphVisualizer.vue";
import OlapGraphVisualizer from "../../components/OlapGraphVisualizer.vue";
export default {
    components: { BasicHeader, Tabs, OltpGraphVisualizer, OlapGraphVisualizer },
    data() {
        return {
            visualizerTabs: [
                {
                    name: "OLAP (Analytical)",
                    id: "1",
                    slot: "olap"
                },
                {
                    name: "OLTP (Real Time)",
                    id: "2",
                    slot: "oltp"
                }
            ]
        }
    },
}
</script>

<style scoped></style>